import React from 'react';
import Seo from '../components/seo';
import asset from '../lib/asset';
import Layout from '../components/layout';

export default function () {
  return (
    <Layout>
      <Seo title="Publicaciones" />
      <h1>Publicaciones:</h1>
      <p>Abajo están varias publicaciones en texto. </p>
      <h2>Esta Grande Salvación - Robert Barclay</h2>
      <table
        className="sermon_table"
        width="646"
        border="0"
        cellSpacing="0"
        cellPadding="0"
      >
        <tbody>
          <tr>
            <td width="469">Esta Grande Salvación</td>
            <td width="48">
              <div align="center">
                <a href="/flp-assets/es/robert-barclay/esta-grande-salvacion/updated/Esta_Grande_Salvación--updated.mobi,637407,1574109192748">
                  kindle
                </a>
              </div>
            </td>
            <td width="42">
              <div align="center">
                <a href="https://nyc3.digitaloceanspaces.com/flp-assets/es/robert-barclay/esta-grande-salvacion/updated/Esta_Grande_Salvaci%C3%B3n--updated.epub">
                  epub
                </a>
              </div>
            </td>
            <td width="38">
              <div align="center">
                <a href="https://nyc3.digitaloceanspaces.com/flp-assets/es/robert-barclay/esta-grande-salvacion/updated/Esta_Grande_Salvaci%C3%B3n--updated.pdf">
                  pdf
                </a>
              </div>
            </td>
            <td width="49">
              <div align="center"></div>
            </td>
          </tr>
        </tbody>
      </table>
      <h2>Algunos de los Misterios del Reino Declarados - Francis Howgill</h2>
      <table
        className="sermon_table"
        width="646"
        border="0"
        cellSpacing="0"
        cellPadding="0"
      >
        <tbody>
          <tr>
            <td width="469">Algunos de los Misterios del Reino Declarados</td>
            <td width="48">
              <div align="center">
                <a href={asset('publicaciones/fhowgill/algunos_de_los_misterios.mobi')}>
                  kindle
                </a>
              </div>
            </td>
            <td width="42">
              <div align="center">
                <a href={asset('publicaciones/fhowgill/algunos_de_los_misterios.epub')}>
                  epub
                </a>
              </div>
            </td>
            <td width="38">
              <div align="center">
                <a href={asset('publicaciones/fhowgill/algunos_de_los_misterios.pdf')}>
                  pdf
                </a>
              </div>
            </td>
            <td width="49">
              <div align="center"></div>
            </td>
          </tr>
        </tbody>
      </table>
      <h2>Un Largo Viaje desde Babilonia hasta Bet-el - Stephen Crisp</h2>
      <table
        className="sermon_table"
        width="646"
        border="0"
        cellSpacing="0"
        cellPadding="0"
      >
        <tbody>
          <tr>
            <td width="469">
              Un Largo Viaje desde Babilonia hasta Bet-el - Una Alegoría
            </td>
            <td width="48">
              <div align="center">
                <a href={asset('publicaciones/stephencrisp/babilonia_hasta_betel.mobi')}>
                  kindle
                </a>
              </div>
            </td>
            <td width="42">
              <div align="center">
                <a href={asset('publicaciones/stephencrisp/babilonia_hasta_betel.epub')}>
                  epub
                </a>
              </div>
            </td>
            <td width="38">
              <div align="center">
                <a href={asset('publicaciones/stephencrisp/babilonia_hasta_betel.pdf')}>
                  pdf
                </a>
              </div>
            </td>
            <td width="49">
              <div align="center">
                <a
                  href={asset('publicaciones/stephencrisp/Babilonia_hacia_Betel_hq.mp3')}
                >
                  audio
                </a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <h2>No Cruz, No Corona - William Penn</h2>
      <table
        className="sermon_table"
        width="646"
        border="0"
        cellSpacing="0"
        cellPadding="0"
      >
        <tbody>
          <tr>
            <td width="476">No Cruz, No Corona</td>
            <td width="49">
              <div align="center">
                <a href={asset('publicaciones/wpenn/No_Cruz_No_Corona.mobi')}>kindle</a>
              </div>
            </td>
            <td width="40">
              <div align="center">
                <a href={asset('publicaciones/wpenn/No_Cruz_No_Corona.epub')}>epub</a>
              </div>
            </td>
            <td width="33">
              <div align="center">
                <a href={asset('publicaciones/wpenn/No_Cruz_No_Corona.pdf')}>pdf</a>
              </div>
            </td>
            <td width="48">
              <div align="center"></div>
            </td>
          </tr>
        </tbody>
      </table>
      <h2>Robert Barclay</h2>
      <table
        className="sermon_table"
        width="646"
        border="0"
        cellSpacing="0"
        cellPadding="0"
      >
        <tbody>
          <tr>
            <td>Esperando en el Señor</td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/barclay/esperando/esperando_v1.mobi')}>
                  kindle
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/barclay/esperando/esperando_v1.epub')}>
                  epub
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/barclay/esperando/esperando_v1.pdf')}>
                  pdf
                </a>
              </div>
            </td>
            <td>
              <div align="center"></div>
            </td>
          </tr>
          <tr>
            <td width="476">Consideraciones sobre el Entretenimiento y la Recreación</td>
            <td width="49">
              <div align="center">
                <a
                  href={asset(
                    'publicaciones/barclay/entretenimiento_recreacion/entretenimiento_recreacion.mobi',
                  )}
                >
                  kindle
                </a>
              </div>
            </td>
            <td width="40">
              <div align="center">
                <a
                  href={asset(
                    'publicaciones/barclay/entretenimiento_recreacion/entretenimiento_recreacion.epub',
                  )}
                >
                  epub
                </a>
              </div>
            </td>
            <td width="33">
              <div align="center">
                <a
                  href={asset(
                    'publicaciones/barclay/entretenimiento_recreacion/entretenimiento_recreacion.pdf',
                  )}
                >
                  pdf
                </a>
              </div>
            </td>
            <td width="48">
              <div align="center"></div>
            </td>
          </tr>
        </tbody>
      </table>
      <h2>El Estado Original y Presente del Hombre - Joseph Phipps</h2>
      <table
        className="sermon_table"
        width="646"
        border="0"
        cellSpacing="0"
        cellPadding="0"
      >
        <tbody>
          <tr>
            <td width="476">El Estado Original y Presente del Hombre</td>
            <td width="49">
              <div align="center">
                <a
                  href={asset(
                    'publicaciones/josephphipps/estado_original_y_presente_del_hombre.mobi',
                  )}
                >
                  kindle
                </a>
              </div>
            </td>
            <td width="40">
              <div align="center">
                <a
                  href={asset(
                    'publicaciones/josephphipps/estado_original_y_presente_del_hombre.epub',
                  )}
                >
                  epub
                </a>
              </div>
            </td>
            <td width="33">
              <div align="center">
                <a
                  href={asset(
                    'publicaciones/josephphipps/estado_original_y_presente_del_hombre.pdf',
                  )}
                >
                  pdf
                </a>
              </div>
            </td>
            <td width="48">
              <div align="center"></div>
            </td>
          </tr>
        </tbody>
      </table>
      <h2>Los Escritos de Isaac Penington - Volumen 1 — LIBRO ENTERO</h2>
      <table
        className="sermon_table"
        width="646"
        border="0"
        cellSpacing="0"
        cellPadding="0"
      >
        <tbody>
          <tr>
            <td width="476">Los Escritos de Isaac Penington - Volumen 1</td>
            <td width="49">
              <div align="center">
                <a
                  href={asset(
                    'publicaciones/isaacpenington/Escritos_de_Isaac_Penington_vol_1.mobi',
                  )}
                >
                  kindle
                </a>
              </div>
            </td>
            <td width="40">
              <div align="center">
                <a
                  href={asset(
                    'publicaciones/isaacpenington/Escritos_de_Isaac_Penington_vol_1.epub',
                  )}
                >
                  epub
                </a>
              </div>
            </td>
            <td width="33">
              <div align="center">
                <a
                  href={asset(
                    'publicaciones/isaacpenington/Escritos_de_Isaac_Penington_vol_1.pdf',
                  )}
                >
                  pdf
                </a>
              </div>
            </td>
            <td width="48">
              <div align="center"></div>
            </td>
          </tr>
        </tbody>
      </table>
      <h2>Los Escritos de Isaac Penington - Volumen 1 — Capítulos Individuales</h2>
      <table
        className="sermon_table"
        width="646"
        border="0"
        cellSpacing="0"
        cellPadding="0"
      >
        <tbody>
          <tr>
            <td width="476">Cap. 1 - Biografía de Isaac Penington</td>
            <td width="49">
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/IP_Vol1_Cap01.mobi')}>
                  kindle
                </a>
              </div>
            </td>
            <td width="40">
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/IP_Vol1_Cap01.epub')}>
                  epub
                </a>
              </div>
            </td>
            <td width="33">
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/IP_Vol1_Cap01.pdf')}>pdf</a>
              </div>
            </td>
            <td width="48">
              <div align="center">
                <a
                  href={asset(
                    'publicaciones/isaacpenington/IP_Audiobook/IP_V1_Chap_01_HQ.mp3',
                  )}
                >
                  audio
                </a>
              </div>
            </td>
          </tr>
          <tr>
            <td>Cap. 2 - El Camino de la Vida y de la Muerte Hecho Manifesto</td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/IP_Vol1_Cap02.mobi')}>
                  kindle
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/IP_Vol1_Cap02.epub')}>
                  epub
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/IP_Vol1_Cap02.pdf')}>pdf</a>
              </div>
            </td>
            <td>
              <div align="center">
                <a
                  href={asset(
                    'publicaciones/isaacpenington/IP_Audiobook/IP_V1_Chap_02_HQ.mp3',
                  )}
                >
                  audio
                </a>
              </div>
            </td>
          </tr>
          <tr>
            <td>Cap. 3 - Algunos Principios que Guían Hacia Afuera de la Apostasía</td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/IP_Vol1_Cap03.mobi')}>
                  kindle
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/IP_Vol1_Cap03.epub')}>
                  epub
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/IP_Vol1_Cap03.pdf')}>pdf</a>
              </div>
            </td>
            <td>
              <div align="center">
                <a
                  href={asset(
                    'publicaciones/isaacpenington/IP_Audiobook/IP_V1_Chap_03_HQ.mp3',
                  )}
                >
                  audio
                </a>
              </div>
            </td>
          </tr>
          <tr>
            <td>Cap. 4 - El Hacha está Puesta a la Raíz del Árbol Corrupto</td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/IP_Vol1_Cap04.mobi')}>
                  kindle
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/IP_Vol1_Cap04.epub')}>
                  epub
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/IP_Vol1_Cap04.pdf')}>pdf</a>
              </div>
            </td>
            <td>
              <div align="center">
                <a
                  href={asset(
                    'publicaciones/isaacpenington/IP_Audiobook/IP_V1_Chap_04_HQ.mp3',
                  )}
                >
                  audio
                </a>
              </div>
            </td>
          </tr>
          <tr>
            <td>Cap. 5 - En Busca de las Ovejas Esparcidas</td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/IP_Vol1_Cap05.mobi')}>
                  kindle
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/IP_Vol1_Cap05.epub')}>
                  epub
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/IP_Vol1_Cap05.pdf')}>pdf</a>
              </div>
            </td>
            <td>
              <div align="center">
                <a
                  href={asset(
                    'publicaciones/isaacpenington/IP_Audiobook/IP_V1_Chap_05_HQ.mp3',
                  )}
                >
                  audio
                </a>
              </div>
            </td>
          </tr>
          <tr>
            <td>Cap. 6 - Babilonia la Grande - La Ciudad de Confusión</td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/IP_Vol1_Cap06.mobi')}>
                  kindle
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/IP_Vol1_Cap06.epub')}>
                  epub
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/IP_Vol1_Cap06.pdf')}>pdf</a>
              </div>
            </td>
            <td>
              <div align="center">
                <a
                  href={asset(
                    'publicaciones/isaacpenington/IP_Audiobook/IP_V1_Chap_06_HQ.mp3',
                  )}
                >
                  audio
                </a>
              </div>
            </td>
          </tr>
          <tr>
            <td>Cap. 7 - Las Sagradas Escrituras</td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/IP_Vol1_Cap07.mobi')}>
                  kindle
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/IP_Vol1_Cap07.epub')}>
                  epub
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/IP_Vol1_Cap07.pdf')}>pdf</a>
              </div>
            </td>
            <td>
              <div align="center">
                <a
                  href={asset(
                    'publicaciones/isaacpenington/IP_Audiobook/IP_V1_Chap_07_HQ.mp3',
                  )}
                >
                  audio
                </a>
              </div>
            </td>
          </tr>
          <tr>
            <td>Cap. 8 - La Autoridad y Gobierno que Cristo Excluyó de Su Iglesia</td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/IP_Vol1_Cap08.mobi')}>
                  kindle
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/IP_Vol1_Cap08.epub')}>
                  epub
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/IP_Vol1_Cap08.pdf')}>pdf</a>
              </div>
            </td>
            <td>
              <div align="center">
                <a
                  href={asset(
                    'publicaciones/isaacpenington/IP_Audiobook/IP_V1_Chap_08_HQ.mp3',
                  )}
                >
                  audio
                </a>
              </div>
            </td>
          </tr>
          <tr>
            <td>Cap. 9 - El Nuevo Pacto del Evangelio y el Antiguo Pacto de la Ley</td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/IP_Vol1_Cap09.mobi')}>
                  kindle
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/IP_Vol1_Cap09.epub')}>
                  epub
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/IP_Vol1_Cap09.pdf')}>pdf</a>
              </div>
            </td>
            <td>
              <div align="center">
                <a
                  href={asset(
                    'publicaciones/isaacpenington/IP_Audiobook/IP_V1_Chap_09_HQ.mp3',
                  )}
                >
                  audio
                </a>
              </div>
            </td>
          </tr>
          <tr>
            <td>Cap. 10 - La Oración, El Ministerio, La Sabiduría, Y el Reino</td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/IP_Vol1_Cap10.mobi')}>
                  kindle
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/IP_Vol1_Cap10.epub')}>
                  epub
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/IP_Vol1_Cap10.pdf')}>pdf</a>
              </div>
            </td>
            <td>
              <div align="center">
                <a
                  href={asset(
                    'publicaciones/isaacpenington/IP_Audiobook/IP_V1_Chap_10_HQ.mp3',
                  )}
                >
                  audio
                </a>
              </div>
            </td>
          </tr>
          <tr>
            <td>Cap. 11 - Algunas Directrices para el Alma Anhelante</td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/IP_Vol1_Cap11.mobi')}>
                  kindle
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/IP_Vol1_Cap11.epub')}>
                  epub
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/IP_Vol1_Cap11.pdf')}>pdf</a>
              </div>
            </td>
            <td>
              <div align="center">
                <a
                  href={asset(
                    'publicaciones/isaacpenington/IP_Audiobook/IP_V1_Chap_11_HQ.mp3',
                  )}
                >
                  audio
                </a>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              Cap. 12 - Algunas Preguntas y Respuestas Para Que los Ojos Sean Abiertos
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/IP_Vol1_Cap12.mobi')}>
                  kindle
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/IP_Vol1_Cap12.epub')}>
                  epub
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/IP_Vol1_Cap12.pdf')}>pdf</a>
              </div>
            </td>
            <td>
              <div align="center">
                <a
                  href={asset(
                    'publicaciones/isaacpenington/IP_Audiobook/IP_V1_Chap_12_HQ.mp3',
                  )}
                >
                  audio
                </a>
              </div>
            </td>
          </tr>
          <tr>
            <td>Cap. 13 - La Suma y Sustancia de la Verdadera Religión</td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/IP_Vol1_Cap13.mobi')}>
                  kindle
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/IP_Vol1_Cap13.epub')}>
                  epub
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/IP_Vol1_Cap13.pdf')}>pdf</a>
              </div>
            </td>
            <td>
              <div align="center">
                <a
                  href={asset(
                    'publicaciones/isaacpenington/IP_Audiobook/IP_V1_Chap_13_HQ.mp3',
                  )}
                >
                  audio
                </a>
              </div>
            </td>
          </tr>
          <tr>
            <td>Cap. 14 - Las Dos Semillas</td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/IP_Vol1_Cap14.mobi')}>
                  kindle
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/IP_Vol1_Cap14.epub')}>
                  epub
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/IP_Vol1_Cap14.pdf')}>pdf</a>
              </div>
            </td>
            <td>
              <div align="center">
                <a
                  href={asset(
                    'publicaciones/isaacpenington/IP_Audiobook/IP_V1_Chap_14_HQ.mp3',
                  )}
                >
                  audio
                </a>
              </div>
            </td>
          </tr>
          <tr>
            <td>Cap. 15 - Cómo Dicernir las Enseñanzas de Cristo</td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/IP_Vol1_Cap15.mobi')}>
                  kindle
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/IP_Vol1_Cap15.epub')}>
                  epub
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/IP_Vol1_Cap15.pdf')}>pdf</a>
              </div>
            </td>
            <td>
              <div align="center">
                <a
                  href={asset(
                    'publicaciones/isaacpenington/IP_Audiobook/IP_V1_Chap_15_HQ.mp3',
                  )}
                >
                  audio
                </a>
              </div>
            </td>
          </tr>
          <tr>
            <td>Cap. 16a - Las Cartas de Isaac Penington - parte 1</td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/IP_Vol1_Cap16a.mobi')}>
                  kindle
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/IP_Vol1_Cap16a.epub')}>
                  epub
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/IP_Vol1_Cap16a.pdf')}>pdf</a>
              </div>
            </td>
            <td>
              <div align="center">
                <a
                  href={asset(
                    'publicaciones/isaacpenington/IP_Audiobook/IP_V1_Chap_16a_HQ.mp3',
                  )}
                >
                  audio
                </a>
              </div>
            </td>
          </tr>
          <tr>
            <td>Cap. 16b - Las Cartas de Isaac Penington - parte 2</td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/IP_Vol1_Cap16b.mobi')}>
                  kindle
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/IP_Vol1_Cap16b.epub')}>
                  epub
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/IP_Vol1_Cap16b.pdf')}>pdf</a>
              </div>
            </td>
            <td>
              <div align="center">
                <a
                  href={asset(
                    'publicaciones/isaacpenington/IP_Audiobook/IP_V1_Chap_16b_HQ.mp3',
                  )}
                >
                  audio
                </a>
              </div>
            </td>
          </tr>
          <tr>
            <td>Cap. 16c - Las Cartas de Isaac Penington - parte 3</td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/IP_Vol1_Cap16c.mobi')}>
                  kindle
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/IP_Vol1_Cap16c.epub')}>
                  epub
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/IP_Vol1_Cap16c.pdf')}>pdf</a>
              </div>
            </td>
            <td>
              <div align="center">
                <a
                  href={asset(
                    'publicaciones/isaacpenington/IP_Audiobook/IP_V1_Chap_16c_HQ.mp3',
                  )}
                >
                  audio
                </a>
              </div>
            </td>
          </tr>
          <tr>
            <td>Cap. 16d - Las Cartas de Isaac Penington - parte 4</td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/IP_Vol1_Cap16d.mobi')}>
                  kindle
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/IP_Vol1_Cap16d.epub')}>
                  epub
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/IP_Vol1_Cap16d.pdf')}>pdf</a>
              </div>
            </td>
            <td>
              <div align="center">
                <a
                  href={asset(
                    'publicaciones/isaacpenington/IP_Audiobook/IP_V1_Chap_16d_HQ.mp3',
                  )}
                >
                  audio
                </a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <h2>Los Escritos de Isaac Penington - Volumen 2 — LIBRO ENTERO</h2>
      <table
        className="sermon_table"
        width="646"
        border="0"
        cellSpacing="0"
        cellPadding="0"
      >
        <tbody>
          <tr>
            <td width="476">Los Escritos de Isaac Penington - Volumen 2</td>
            <td width="49">
              <div align="center">
                <a href="https://flp-assets.nyc3.digitaloceanspaces.com/es/isaac-penington/escritos-volumen-2/updated/Escritos_de_Isaac_Penington_vol_2--updated.mobi">
                  kindle
                </a>
              </div>
            </td>
            <td width="40">
              <div align="center">
                <a href="https://flp-assets.nyc3.digitaloceanspaces.com/es/isaac-penington/escritos-volumen-2/updated/Escritos_de_Isaac_Penington_vol_2--updated.epub">
                  epub
                </a>
              </div>
            </td>
            <td width="33">
              <div align="center">
                <a href="https://flp-assets.nyc3.digitaloceanspaces.com/es/isaac-penington/escritos-volumen-2/updated/Escritos_de_Isaac_Penington_vol_2--updated.pdf">
                  pdf
                </a>
              </div>
            </td>
            <td width="48">
              <div align="center"></div>
            </td>
          </tr>
        </tbody>
      </table>
      <h2>Los Escritos de Isaac Penington — Volumen 2 — Capítulos Individuales</h2>
      <table
        width="641"
        height="322"
        border="0"
        cellPadding="0"
        cellSpacing="0"
        className="sermon_table"
      >
        <tbody>
          <tr>
            <td width="470" height="25">
              Cap. 1 - Conocimiento Espiritual
            </td>
            <td width="46">
              <div align="center">
                <a
                  href={asset('publicaciones/isaacpenington/ip_vol2/IP_Vol2_Cap01.mobi')}
                >
                  kindle
                </a>
              </div>
            </td>
            <td width="41">
              <div align="center">
                <a
                  href={asset('publicaciones/isaacpenington/ip_vol2/IP_Vol2_Cap01.epub')}
                >
                  epub
                </a>
              </div>
            </td>
            <td width="37">
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/ip_vol2/IP_Vol2_Cap01.pdf')}>
                  pdf
                </a>
              </div>
            </td>
            <td width="47">
              <div align="center">
                <a
                  href={asset(
                    'publicaciones/isaacpenington/ip_vol2/IPv2_audiobook/IPv2_cap_01_HQ.mp3',
                  )}
                >
                  audio
                </a>
              </div>
            </td>
          </tr>
          <tr>
            <td height="27">
              Cap. 2 - Algunas Piedras de Tropiezo Eliminadas del Camino
            </td>
            <td>
              <div align="center">
                <a
                  href={asset('publicaciones/isaacpenington/ip_vol2/IP_Vol2_Cap02.mobi')}
                >
                  kindle
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a
                  href={asset('publicaciones/isaacpenington/ip_vol2/IP_Vol2_Cap02.epub')}
                >
                  epub
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/ip_vol2/IP_Vol2_Cap02.pdf')}>
                  pdf
                </a>
              </div>
            </td>
            <td></td>
          </tr>
          <tr>
            <td height="27">
              Cap. 3 - Una Defensa de la Verdad Santa y del Pueblo Santo de Dios
            </td>
            <td>
              <div align="center">
                <a
                  href={asset('publicaciones/isaacpenington/ip_vol2/IP_Vol2_Cap03.mobi')}
                >
                  kindle
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a
                  href={asset('publicaciones/isaacpenington/ip_vol2/IP_Vol2_Cap03.epub')}
                >
                  epub
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/ip_vol2/IP_Vol2_Cap03.pdf')}>
                  pdf
                </a>
              </div>
            </td>
            <td></td>
          </tr>
          <tr>
            <td height="27">Cap. 4 - La Verdad Desnuda</td>
            <td>
              <div align="center">
                <a
                  href={asset('publicaciones/isaacpenington/ip_vol2/IP_Vol2_Cap04.mobi')}
                >
                  kindle
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a
                  href={asset('publicaciones/isaacpenington/ip_vol2/IP_Vol2_Cap04.epub')}
                >
                  epub
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/ip_vol2/IP_Vol2_Cap04.pdf')}>
                  pdf
                </a>
              </div>
            </td>
            <td></td>
          </tr>
          <tr>
            <td height="27">Cap. 5 - Las Experiencias</td>
            <td>
              <div align="center">
                <a
                  href={asset('publicaciones/isaacpenington/ip_vol2/IP_Vol2_Cap05.mobi')}
                >
                  kindle
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a
                  href={asset('publicaciones/isaacpenington/ip_vol2/IP_Vol2_Cap05.epub')}
                >
                  epub
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/ip_vol2/IP_Vol2_Cap05.pdf')}>
                  pdf
                </a>
              </div>
            </td>
            <td></td>
          </tr>
          <tr>
            <td height="27">Cap. 6 - Un Llamado al Verdadero Cristianismo</td>
            <td>
              <div align="center">
                <a
                  href={asset('publicaciones/isaacpenington/ip_vol2/IP_Vol2_Cap06.mobi')}
                >
                  kindle
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a
                  href={asset('publicaciones/isaacpenington/ip_vol2/IP_Vol2_Cap06.epub')}
                >
                  epub
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/ip_vol2/IP_Vol2_Cap06.pdf')}>
                  pdf
                </a>
              </div>
            </td>
            <td></td>
          </tr>
          <tr>
            <td height="27">Cap. 7 - A los Judíos Según la Carne y Según el Espíritu</td>
            <td>
              <div align="center">
                <a
                  href={asset('publicaciones/isaacpenington/ip_vol2/IP_Vol2_Cap07.mobi')}
                >
                  kindle
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a
                  href={asset('publicaciones/isaacpenington/ip_vol2/IP_Vol2_Cap07.epub')}
                >
                  epub
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/ip_vol2/IP_Vol2_Cap07.pdf')}>
                  pdf
                </a>
              </div>
            </td>
            <td></td>
          </tr>
          <tr>
            <td height="27">Cap. 8 - El Testimonio de la Verdad</td>
            <td>
              <div align="center">
                <a
                  href={asset('publicaciones/isaacpenington/ip_vol2/IP_Vol2_Cap08.mobi')}
                >
                  kindle
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a
                  href={asset('publicaciones/isaacpenington/ip_vol2/IP_Vol2_Cap08.epub')}
                >
                  epub
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/ip_vol2/IP_Vol2_Cap08.pdf')}>
                  pdf
                </a>
              </div>
            </td>
            <td></td>
          </tr>
          <tr>
            <td height="27">
              Cap. 9 - La Vida e Inmortalidad Sacadas a la Luz por el Evangelio
            </td>
            <td>
              <div align="center">
                <a
                  href={asset('publicaciones/isaacpenington/ip_vol2/IP_Vol2_Cap09.mobi')}
                >
                  kindle
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a
                  href={asset('publicaciones/isaacpenington/ip_vol2/IP_Vol2_Cap09.epub')}
                >
                  epub
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/ip_vol2/IP_Vol2_Cap09.pdf')}>
                  pdf
                </a>
              </div>
            </td>
            <td></td>
          </tr>
          <tr>
            <td height="27">Cap. 10 - La Ministración del Espíritu y Poder</td>
            <td>
              <div align="center">
                <a
                  href={asset('publicaciones/isaacpenington/ip_vol2/IP_Vol2_Cap10.mobi')}
                >
                  kindle
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a
                  href={asset('publicaciones/isaacpenington/ip_vol2/IP_Vol2_Cap10.epub')}
                >
                  epub
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/ip_vol2/IP_Vol2_Cap10.pdf')}>
                  pdf
                </a>
              </div>
            </td>
            <td></td>
          </tr>
          <tr>
            <td height="27">Cap. 11 - El Bautismo de Cristo</td>
            <td>
              <div align="center">
                <a
                  href={asset('publicaciones/isaacpenington/ip_vol2/IP_Vol2_Cap11.mobi')}
                >
                  kindle
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a
                  href={asset('publicaciones/isaacpenington/ip_vol2/IP_Vol2_Cap11.epub')}
                >
                  epub
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/ip_vol2/IP_Vol2_Cap11.pdf')}>
                  pdf
                </a>
              </div>
            </td>
            <td></td>
          </tr>
          <tr>
            <td height="27">
              Cap. 12 - Un Testimonio Adicional Sobre la Obra de Dios en Nuestros
              Corazones
            </td>
            <td>
              <div align="center">
                <a
                  href={asset('publicaciones/isaacpenington/ip_vol2/IP_Vol2_Cap12.mobi')}
                >
                  kindle
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a
                  href={asset('publicaciones/isaacpenington/ip_vol2/IP_Vol2_Cap12.epub')}
                >
                  epub
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/ip_vol2/IP_Vol2_Cap12.pdf')}>
                  pdf
                </a>
              </div>
            </td>
            <td></td>
          </tr>
          <tr>
            <td height="27">Cap. 13 - Las Enseñanzas de Dios y la Ley de Cristo</td>
            <td>
              <div align="center">
                <a
                  href={asset('publicaciones/isaacpenington/ip_vol2/IP_Vol2_Cap13.mobi')}
                >
                  kindle
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a
                  href={asset('publicaciones/isaacpenington/ip_vol2/IP_Vol2_Cap13.epub')}
                >
                  epub
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/ip_vol2/IP_Vol2_Cap13.pdf')}>
                  pdf
                </a>
              </div>
            </td>
            <td></td>
          </tr>
          <tr>
            <td height="27">Cap. 14 - La Semilla del Reino</td>
            <td>
              <div align="center">
                <a
                  href={asset('publicaciones/isaacpenington/ip_vol2/IP_Vol2_Cap14.mobi')}
                >
                  kindle
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a
                  href={asset('publicaciones/isaacpenington/ip_vol2/IP_Vol2_Cap14.epub')}
                >
                  epub
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/isaacpenington/ip_vol2/IP_Vol2_Cap14.pdf')}>
                  pdf
                </a>
              </div>
            </td>
            <td></td>
          </tr>
          <tr>
            <td height="27">Cap. 15 - Cartas de Isaac Penington</td>
            <td>
              <div align="center">
                <a href="https://nyc3.digitaloceanspaces.com/flp-assets/zoe/publicaciones/isaacpenington/ip_vol2/IP_Vol2_Cap15..mobi">
                  kindle
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href="https://nyc3.digitaloceanspaces.com/flp-assets/zoe/publicaciones/isaacpenington/ip_vol2/IP_Vol2_Cap15..epub">
                  epub
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href="https://nyc3.digitaloceanspaces.com/flp-assets/zoe/publicaciones/isaacpenington/ip_vol2/IP_Vol2_Cap15.pdf">
                  pdf
                </a>
              </div>
            </td>
            <td></td>
          </tr>
        </tbody>
      </table>
      <h2>La Verdad en Lo Íntimo — Capítulos Individuales</h2>
      <table
        width="641"
        height="214"
        border="0"
        cellPadding="0"
        cellSpacing="0"
        className="sermon_table"
      >
        <tbody>
          <tr>
            <td width="470" height="25">
              Cap. 1 - Introducción
            </td>
            <td width="46">
              <div align="center">
                <a href={asset('publicaciones/verdadenlointimo/01_Introduccion.mobi')}>
                  kindle
                </a>
              </div>
            </td>
            <td width="41">
              <div align="center">
                <a href={asset('publicaciones/verdadenlointimo/01_Introduccion.epub')}>
                  epub
                </a>
              </div>
            </td>
            <td width="37">
              <div align="center">
                <a href={asset('publicaciones/verdadenlointimo/01_Introduccion.pdf')}>
                  pdf
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/verdadenlointimo/01_Introducción.mp3')}>
                  audio
                </a>
              </div>
            </td>
          </tr>
          <tr>
            <td height="27">Cap. 2 - La Vida de Stephen Crisp</td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/verdadenlointimo/02_Stephen_Crisp.mobi')}>
                  kindle
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/verdadenlointimo/02_Stephen_Crisp.epub')}>
                  epub
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/verdadenlointimo/02_Stephen_Crisp.pdf')}>
                  pdf
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/verdadenlointimo/02_Stephen_Crisp.mp3')}>
                  audio
                </a>
              </div>
            </td>
          </tr>
          <tr>
            <td height="27">Cap. 3 - La Vida de John Richardson</td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/verdadenlointimo/03_John_Richardson.mobi')}>
                  kindle
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/verdadenlointimo/03_John_Richardson.epub')}>
                  epub
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/verdadenlointimo/03_John_Richardson.pdf')}>
                  pdf
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href="https://nyc3.digitaloceanspaces.com/flp-assets/zoe/publicaciones/verdadenlointimo/03_John_Richardson.mp3">
                  audio
                </a>
              </div>
            </td>
          </tr>
          <tr>
            <td height="27">Cap. 4 - La Carta de Elizabeth Webb</td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/verdadenlointimo/04_Elizasbeth_Webb.mobi')}>
                  kindle
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/verdadenlointimo/04_Elizasbeth_Webb.epub')}>
                  epub
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/verdadenlointimo/04_Elizasbeth_Webb.pdf')}>
                  pdf
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/verdadenlointimo/04_Elizabeth_Webb.mp3')}>
                  audio
                </a>
              </div>
            </td>
          </tr>
          <tr>
            <td height="27">Cap. 5 - El Diario de John Burnyeat</td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/verdadenlointimo/05_John_Burnyeat.mobi')}>
                  kindle
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/verdadenlointimo/05_John_Burnyeat.epub')}>
                  epub
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/verdadenlointimo/05_John_Burnyeat.pdf')}>
                  pdf
                </a>
              </div>
            </td>
            <td></td>
          </tr>
          <tr>
            <td height="27">Cap. 6 - La Vida de Joseph Pike</td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/verdadenlointimo/06_Joseph_Pike.mobi')}>
                  kindle
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/verdadenlointimo/06_Joseph_Pike.epub')}>
                  epub
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/verdadenlointimo/06_Joseph_Pike.pdf')}>
                  pdf
                </a>
              </div>
            </td>
            <td></td>
          </tr>
          <tr>
            <td height="27">Cap. 7 - El Diario de John Griffith</td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/verdadenlointimo/07_John_Griffith.mobi')}>
                  kindle
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/verdadenlointimo/07_John_Griffith.epub')}>
                  epub
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/verdadenlointimo/07_John_Griffith.pdf')}>
                  pdf
                </a>
              </div>
            </td>
            <td></td>
          </tr>
          <tr>
            <td height="27">Cap. 8 - Las Memorias de John Crook</td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/verdadenlointimo/08_John_Crook.mobi')}>
                  kindle
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/verdadenlointimo/08_John_Crook.epub')}>
                  epub
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/verdadenlointimo/08_John_Crook.pdf')}>
                  pdf
                </a>
              </div>
            </td>
            <td></td>
          </tr>
          <tr>
            <td height="27">Cap. 9 - La Vida de Elizabeth Stirredge</td>
            <td>
              <div align="center">
                <a href="https://nyc3.digitaloceanspaces.com/flp-assets/zoe/publicaciones/verdadenlointimo/09_Elizabeth_Stirredge.mobi">
                  kindle
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href="https://nyc3.digitaloceanspaces.com/flp-assets/zoe/publicaciones/verdadenlointimo/09_Elizabeth_Stirredge.epub">
                  epub
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href="https://nyc3.digitaloceanspaces.com/flp-assets/zoe/publicaciones/verdadenlointimo/09_Elizabeth_Stirredge.pdf">
                  pdf
                </a>
              </div>
            </td>
            <td></td>
          </tr>
          <tr>
            <td height="27">Cap. 10 - El Diario de Charles Marshall</td>
            <td>
              <div align="center">
                <a href="https://nyc3.digitaloceanspaces.com/flp-assets/zoe/publicaciones/verdadenlointimo/10_Charles_Marshall.mobi">
                  kindle
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href="https://nyc3.digitaloceanspaces.com/flp-assets/zoe/publicaciones/verdadenlointimo/10_Charles_Marshall.epub">
                  epub
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href="https://nyc3.digitaloceanspaces.com/flp-assets/zoe/publicaciones/verdadenlointimo/10_Charles_Marshall.pdf">
                  pdf
                </a>
              </div>
            </td>
            <td></td>
          </tr>
          <tr>
            <td height="27">Cap. 11 - La Vida de Thomas Story</td>
            <td>
              <div align="center">
                <a href="https://nyc3.digitaloceanspaces.com/flp-assets/zoe/publicaciones/verdadenlointimo/11_Thomas_Story.mobi">
                  kindle
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href="https://nyc3.digitaloceanspaces.com/flp-assets/zoe/publicaciones/verdadenlointimo/11_Thomas_Story.epub">
                  epub
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href="https://nyc3.digitaloceanspaces.com/flp-assets/zoe/publicaciones/verdadenlointimo/11_Thomas_Story.pdf">
                  pdf
                </a>
              </div>
            </td>
            <td></td>
          </tr>
        </tbody>
      </table>
      <h2>Los Sufrimientos de Catharine Evans y Sarah Cheevers</h2>
      <table
        width="641"
        height="100"
        border="0"
        cellPadding="0"
        cellSpacing="0"
        className="sermon_table"
      >
        <tbody>
          <tr>
            <td height="20">
              Un Corto Relato de los Sufrimientos de Catharine Evans y Sarah Cheevers
              <div align="center"></div>
            </td>
            <td width="42">
              <div align="center">
                <a
                  href={asset(
                    'publicaciones/evans-cheevers/Sufrimientos_de_Catharine_Evans_Sarah_Cheevers.mobi',
                  )}
                >
                  kindle
                </a>
              </div>
            </td>
            <td width="44">
              <div align="center">
                <a
                  href={asset(
                    'publicaciones/evans-cheevers/Sufrimientos_de_Catharine_Evans_Sarah_Cheevers.epub',
                  )}
                >
                  epub
                </a>
              </div>
            </td>
            <td width="40">
              <div align="center">
                <a
                  href={asset(
                    'publicaciones/evans-cheevers/Sufrimientos_de_Catharine_Evans_Sarah_Cheevers.pdf',
                  )}
                >
                  pdf
                </a>
              </div>
            </td>
          </tr>
          <tr>
            <td height="20">
              Los Sufrimientos de Catharine Evans y Sarah Cheevers - parte 1
              <div align="center"></div>
            </td>
            <td colSpan="3">
              <div align="center">
                <a
                  href={asset(
                    'publicaciones/evans-cheevers/01_Sufrimientos_de_Catherine_Evans_Sarah_Cheevers_hq.mp3',
                  )}
                >
                  audio
                </a>
              </div>
            </td>
          </tr>
          <tr>
            <td height="20">
              Los Sufrimientos de Catharine Evans y Sarah Cheevers - parte 2
              <div align="center"></div>
            </td>
            <td colSpan="3">
              <div align="center">
                <a
                  href={asset(
                    'publicaciones/evans-cheevers/02_Sufrimientos_de_Catherine_Evans_Sarah_Cheevers_hq.mp3',
                  )}
                >
                  audio
                </a>
              </div>
            </td>
          </tr>
          <tr>
            <td height="20">
              Los Sufrimientos de Catharine Evans y Sarah Cheevers - parte 3
              <div align="center"></div>
            </td>
            <td colSpan="3">
              <div align="center">
                <a
                  href={asset(
                    'publicaciones/evans-cheevers/03_Sufrimientos_de_Catherine_Evans_Sarah_Cheevers_hq.mp3',
                  )}
                >
                  audio
                </a>
              </div>
            </td>
          </tr>
          <tr>
            <td width="515" height="20">
              Los Sufrimientos de Catharine Evans y Sarah Cheevers - parte 4
              <div align="center"></div>
            </td>
            <td colSpan="3">
              <div align="center">
                <a
                  href={asset(
                    'publicaciones/evans-cheevers/04_Sufrimientos_de_Catherine_Evans_Sarah_Cheevers_hq.mp3',
                  )}
                >
                  audio
                </a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <h2>Un Camino Simple - por Stephen Crisp</h2>
      <table
        className="sermon_table"
        width="514"
        border="0"
        cellSpacing="0"
        cellPadding="0"
      >
        <tbody>
          <tr>
            <td width="381">Un Camino Simple</td>
            <td width="51">
              <div align="center">
                <a href={asset('publicaciones/stephencrisp/camino_simple.mobi')}>
                  kindle
                </a>
              </div>
            </td>
            <td width="47">
              <div align="center">
                <a href={asset('publicaciones/stephencrisp/camino_simple.epub')}>epub</a>
              </div>
            </td>
            <td width="35">
              <div align="center">
                <a href={asset('publicaciones/stephencrisp/camino_simple.pdf')}>pdf</a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <h2>La Biografía de James Parnell</h2>
      <table
        className="sermon_table"
        width="514"
        border="0"
        cellSpacing="0"
        cellPadding="0"
      >
        <tbody>
          <tr>
            <td width="381">La Biografía de James Parnell</td>
            <td width="51">
              <div align="center">
                <a href={asset('publicaciones/jamesparnell/james_parnell.mobi')}>
                  kindle
                </a>
              </div>
            </td>
            <td width="47">
              <div align="center">
                <a href={asset('publicaciones/jamesparnell/james_parnell.epub')}>epub</a>
              </div>
            </td>
            <td width="35">
              <div align="center">
                <a href={asset('publicaciones/jamesparnell/james_parnell.pdf')}>pdf</a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <h2>La Salvación por medio de Cristo - por Thomas Story</h2>
      <table
        className="sermon_table"
        width="514"
        border="0"
        cellSpacing="0"
        cellPadding="0"
      >
        <tbody>
          <tr>
            <td width="381">La Salvación por medio de Cristo</td>
            <td width="51">
              <div align="center">
                <a href={asset('publicaciones/thomasstory/salvacion_por_cristo.mobi')}>
                  kindle
                </a>
              </div>
            </td>
            <td width="47">
              <div align="center">
                <a href={asset('publicaciones/thomasstory/salvacion_por_cristo.epub')}>
                  epub
                </a>
              </div>
            </td>
            <td width="35">
              <div align="center">
                <a href={asset('publicaciones/thomasstory/salvacion_por_cristo.pdf')}>
                  pdf
                </a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <h2>Jason Henderson </h2>
      <table
        className="sermon_table"
        width="514"
        border="0"
        cellSpacing="0"
        cellPadding="0"
      >
        <tbody>
          <tr>
            <td width="383">El Reino de Dios</td>
            <td width="51">
              <div align="center">
                <a href={asset('publicaciones/jasonhenderson/reino_de_dios/reino.mobi')}>
                  kindle
                </a>
              </div>
            </td>
            <td width="46">
              <div align="center">
                <a href={asset('publicaciones/jasonhenderson/reino_de_dios/reino.epub')}>
                  epub
                </a>
              </div>
            </td>
            <td width="34">
              <div align="center">
                <a href={asset('publicaciones/jasonhenderson/reino_de_dios/reino.pdf')}>
                  pdf
                </a>
              </div>
            </td>
          </tr>
          <tr>
            <td>La Gran Apostasía</td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/jasonhenderson/apostasia/apostasia.mobi')}>
                  kindle
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/jasonhenderson/apostasia/apostasia.epub')}>
                  epub
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('publicaciones/jasonhenderson/apostasia/apostasia.pdf')}>
                  pdf
                </a>
              </div>
            </td>
          </tr>
          <tr>
            <td>La Naturaleza de la Obra Consumada de Cristo</td>
            <td>
              <div align="center">
                <a href={asset('mensajes/18/Naturaleza_de_la_Obra_Consumada.mobi')}>
                  kindle
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('mensajes/18/Naturaleza_de_la_Obra_Consumada.epub')}>
                  epub
                </a>
              </div>
            </td>
            <td>
              <div align="center">
                <a href={asset('mensajes/18/Naturaleza_de_la_Obra_Consumada.pdf')}>pdf</a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </Layout>
  );
}
